import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ErrorState } from "@/components/common";
import { GarageFlowLogo } from "@/components/Brand";
import { t } from "@/i18n";

export function GarageError({ message, isAdmin, staff, onSelect, onRetry }) {
  return (
    <div className="mx-auto flex min-h-screen max-w-lg flex-col justify-center gap-6 px-5">
      <GarageFlowLogo />
      <ErrorState message={message} onRetry={onRetry} />
      {isAdmin ? (
        <Button asChild variant="outline" data-testid="garage-error-admin-link"><Link to="/admin/support">{t("support.backToAdmin")}</Link></Button>
      ) : (
        staff.map((m) => (
          <Button key={m.garage_id} variant="outline" onClick={() => onSelect(m.garage_id)} data-testid={`garage-error-select-${m.slug}`}>
            {t("pro.openGarage", { name: m.garage_name })}
          </Button>
        ))
      )}
    </div>
  );
}
